var _rect, _rect2, _rect3, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVehicleMaintce(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.51973,
    y: 0.562699,
    width: 73.9356,
    height: 73.9356,
    rx: 36.9678,
    fill: "#020407",
    fillOpacity: 0.04
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.51973,
    y: 0.562699,
    width: 73.9356,
    height: 73.9356,
    rx: 36.9678,
    stroke: "url(#paint0_linear_706_70411)",
    strokeWidth: 1.07657
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 1.51973,
    y: 0.562699,
    width: 73.9356,
    height: 73.9356,
    rx: 36.9678,
    stroke: "url(#paint1_linear_706_70411)",
    strokeWidth: 1.07657
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_706_70411)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.8889 32.1957C27.9403 26.817 34.9655 24.9734 37.6832 29.5163C37.9404 28.1282 39.1597 27.0735 40.6211 27.0735H42.7014L42.9104 26.8646C43.2994 26.4756 43.2992 25.8444 42.9104 25.4558L39.8926 22.4381C39.5036 22.0491 38.873 22.0491 38.484 22.438L37.3061 23.6157C36.9733 23.4542 36.6316 23.3124 36.2826 23.191V21.5264C36.2826 20.9763 35.8366 20.5303 35.2865 20.5303H31.0188C30.4687 20.5303 30.0227 20.9763 30.0227 21.5264V23.191C29.6737 23.3124 29.332 23.4542 28.9992 23.6157L27.8213 22.4381C27.4324 22.0491 26.8017 22.0492 26.4127 22.4381L23.395 25.4559C23.0059 25.8448 23.0063 26.476 23.395 26.8646L24.5728 28.0423C24.4112 28.3753 24.2694 28.717 24.1481 29.0657H22.4834C21.9333 29.0657 21.4873 29.5117 21.4873 30.0618V34.3295C21.4873 34.8796 21.9333 35.3256 22.4834 35.3256H24.148C24.2694 35.6743 24.4112 36.0159 24.5727 36.349L23.3949 37.5266C23.0059 37.9156 23.0061 38.5468 23.3949 38.9354L26.4127 41.9531C26.8016 42.3421 27.4323 42.3421 27.8213 41.9532L28.0304 41.744V39.6641C28.0304 38.2026 29.0851 36.9833 30.4733 36.7262C28.9265 35.8095 27.8889 34.1241 27.8889 32.1957Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.4909 38.6678H52.8825C52.6887 38.04 52.4366 37.4326 52.1285 36.8505L53.2668 35.7122C53.6558 35.3232 53.6558 34.6925 53.2668 34.3035L50.249 31.2857C49.8604 30.897 49.2294 30.8966 48.8403 31.2857L47.7021 32.4241C47.1201 32.1159 46.5127 31.8639 45.8847 31.6699V30.0615C45.8847 29.5114 45.4387 29.0654 44.8886 29.0654H40.6208C40.0707 29.0654 39.6247 29.5114 39.6247 30.0615V31.6699C38.9968 31.8639 38.3893 32.1159 37.8073 32.4241L36.6691 31.2857C36.1737 30.7905 35.5277 31.0184 35.2605 31.2857L32.2427 34.3035C31.8537 34.6924 31.8537 35.3232 32.2427 35.7122L33.381 36.8505C33.0728 37.4327 32.8208 38.0402 32.627 38.6678H31.0186C30.4684 38.6678 30.0225 39.1138 30.0225 39.6639V43.9315C30.0225 44.4816 30.4684 44.9276 31.0186 44.9276H32.627C32.8208 45.5554 33.0728 46.1628 33.381 46.7448L32.2427 47.8832C31.8537 48.2721 31.8537 48.9028 32.2427 49.2918L35.2605 52.3096C35.6491 52.6983 36.2802 52.6986 36.6691 52.3096L37.8073 51.1713C38.3892 51.4794 38.9967 51.7315 39.6247 51.9254V53.5339C39.6247 54.084 40.0707 54.53 40.6208 54.53H44.8886C45.4387 54.53 45.8847 54.084 45.8847 53.5339V51.9254C46.5126 51.7316 47.1201 51.4795 47.7021 51.1714L48.8403 52.3097C49.2289 52.6984 49.86 52.6987 50.2489 52.3097L53.2667 49.2919C53.6557 48.903 53.6557 48.2722 53.2667 47.8832L52.1284 46.7449C52.4366 46.1628 52.6886 45.5553 52.8824 44.9277H54.4909C55.041 44.9277 55.487 44.4817 55.487 43.9316V39.6639C55.487 39.1138 55.041 38.6678 54.4909 38.6678ZM42.7547 48.1284C39.264 48.1284 36.424 45.2884 36.424 41.7977C36.7718 33.3992 48.739 33.4016 49.0855 41.7978C49.0854 45.2884 46.2454 48.1284 42.7547 48.1284Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.8451 37.4622C40.4224 37.4047 38.4129 39.3764 38.416 41.7984C38.6542 47.5535 46.8555 47.5527 47.0931 41.7984C47.0931 39.4365 45.1956 37.5106 42.8451 37.4622Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.881 32.1956C29.881 32.742 30.0164 33.2571 30.2542 33.7104C30.3984 33.4118 30.5929 33.1363 30.8343 32.895L33.852 29.8773C34.0874 29.6418 34.3692 29.4474 34.6766 29.3019C32.5457 28.1455 29.8572 29.7598 29.881 32.1956Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_706_70411",
    x1: -7.18521,
    y1: 4.25897,
    x2: 75.6912,
    y2: 75.0366,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#024751",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.323723,
    stopColor: "#024751",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_706_70411",
    x1: 90.8146,
    y1: 91.9749,
    x2: 3.70366,
    y2: 30.2713,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#024751"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.544,
    stopColor: "#024751",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_706_70411"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    fill: "white",
    transform: "translate(21.4873 20.5303)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVehicleMaintce);
export default __webpack_public_path__ + "static/media/VehicleMaintce.18d5f3f58d4c2653485ec13e1508590c.svg";
export { ForwardRef as ReactComponent };